import type { Resource } from '../../';
export const product_details_viewCart: Resource = {"default":"View Bag"};
